module.exports = __webpack_public_path__ + "static/media/cooperation61.06a56da8.png";